// src/pages/clab-biodata-pending/components/BulkActionPanel.jsx
import React from 'react';
import { CheckCircleIcon, XCircleIcon } from '@heroicons/react/24/solid';
import SpinnerIcon from '../../../components/ui/SpinnerIcon'; // Adjust path as needed

const BulkActionPanel = ({ selectedCount, onApprove, onReject, disabled = false }) => {
  if (selectedCount === 0) {
    return null;
  }

  return (
    <div className="bg-blue-50 border-l-4 border-blue-400 p-4 mb-4 rounded-r-lg shadow-md flex justify-between items-center">
      <p className="text-sm font-medium text-blue-800">
        <span className="font-bold">{selectedCount}</span> biodata(s) selected.
      </p>
      <div className="flex space-x-3">
        <button
          onClick={onApprove}
          disabled={disabled}
          className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 disabled:bg-green-400 disabled:cursor-not-allowed"
        >
          {disabled ? <SpinnerIcon /> : <CheckCircleIcon className="h-5 w-5 mr-2" />}
          Approve Selected
        </button>
        <button
          onClick={onReject}
          disabled={disabled}
          className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 disabled:bg-red-400 disabled:cursor-not-allowed"
        >
          {disabled ? <SpinnerIcon /> : <XCircleIcon className="h-5 w-5 mr-2" />}
          Reject Selected
        </button>
      </div>
    </div>
  );
};

export default BulkActionPanel;